import { NgStyle } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'rc-calendar-timespan',
  templateUrl: './calendar-timespan.component.html',
  styleUrls: ['./calendar-timespan.component.scss'],
  imports: [NgStyle],
})
export class CalendarTimespanComponent {
  duration = input<number>();
  offset = input<number>();
  periodLength = input<number>();
  startDate = input<string>();
  showLegend = input<boolean>();

  titles = signal<string[]>([]);

  constructor() {
    effect(() => {
      const periodLength = this.periodLength();
      const startDate = this.startDate();

      if (periodLength == null) {
        this.titles.set([]);
        return;
      }

      if (periodLength === 10080) {
        const startDay = moment(startDate).day();
        const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        const titles = weekdays.map((v, i) => {
          const index = (startDay + i + 6) % 7;
          return weekdays[index];
        });
        this.titles.set(titles);
      } else {
        const length = Math.round(periodLength / 60);
        const skipped = Math.floor(length / 24);
        if (skipped > 1) {
          this.titles.set(Array.from({ length: 24 }, (v, i) => (i * skipped).toString()));
        } else {
          this.titles.set(Array.from({ length: length }, (v, i) => i.toString()));
        }
      }
    });
  }

  getPercent(fix: number): number {
    return (fix * 100) / (this.periodLength() ?? 1);
  }

  getDateString(value: number): string {
    if (value === 0) return '00:00';
    const minutes = value % 60;
    const hours = (value - minutes) / 60;
    const hourString = hours < 10 ? `0${hours}` : hours;
    const minuteString = minutes < 10 ? `0${minutes}` : minutes;
    return `${hourString}:${minuteString}`;
  }

  getGeneralString(fix: number): string {
    if (this.periodLength() === 10080) {
      return moment(this.startDate())
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add({ minute: fix })
        .format('ddd HH:mm');
    } else {
      return this.getDateString(fix);
    }
  }
}
